import React from 'react';

import { SVGIcon } from '../../UIKit/index';
import ReviewIntegrations from 'Assets/images/Review-Integrations.svg';

const backgroundStyle = {
    backgroundImage: 'url(' + ReviewIntegrations + ')',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
};
export default function DCAutoCreateDeals(props) {
    return <SVGIcon {...props} viewBox="0 0 512 512" style={backgroundStyle} />;
}
